export const usePageTitle = (title: string) => {
  const prefix = title ? `${title} - ` : ''
  document.title = `${prefix}Theatergruppe Bergheim`
}
